import { Box, styled } from '@mui/material';

// Main chart container
export const ChartSkeletonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 300,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
}));

// Chart area (main plotting area)
export const ChartAreaContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  position: 'relative',
  marginLeft: theme.spacing(6), // Space for Y-axis labels
  marginBottom: theme.spacing(4), // Space for X-axis labels
  marginRight: theme.spacing(3), // Right margin
}));

// Grid lines container
export const GridLinesContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

// Y-axis container
export const YAxisContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: theme.spacing(4), // Account for X-axis space
  width: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  paddingRight: theme.spacing(1),
}));

// X-axis container
export const XAxisContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: theme.spacing(6), // Account for Y-axis space
  right: theme.spacing(3),
  height: theme.spacing(4),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  paddingTop: theme.spacing(1),
}));

// Legend container
export const LegendContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(3),
  marginTop: theme.spacing(2),
  marginLeft: theme.spacing(6), // Align with chart area
}));

// Legend item
export const LegendItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

// Chart line paths container
export const ChartLinesContainer = styled(Box)({
  position: 'absolute',
  top: '10%',
  left: '5%',
  right: '5%',
  bottom: '10%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
});
